export const allDiscountSelector = (state) => state?.discountReducer?.all;
